import { Subscription, SubscriptionStatus } from '@/shared/types/Billing';

import { isSubscriptionActive } from './isSubscriptionActive';
import { isSubscriptionExpired } from './isSubscriptionExpired';

export const getSubscriptionState = (subscription: null | Subscription) => {
  const hasTrialPlan = subscription === null;

  const hasPausedSubscription =
    subscription?.payments_collection_paused || subscription?.status === SubscriptionStatus.Paused;
  const hasExpiredSubscription = Boolean(subscription && isSubscriptionExpired(subscription.current_period_end));
  const hasActiveSubscription = Boolean(
    subscription && isSubscriptionActive(subscription) && !hasExpiredSubscription && !hasPausedSubscription,
  );

  const hasCanceledSubscription = subscription?.status === SubscriptionStatus.Canceled;
  const hasUnpaidSubscription = Boolean(
    subscription && subscription.status === SubscriptionStatus.Unpaid && isSubscriptionExpired(subscription.current_period_end),
  );
  const hasPastDueSubscription = Boolean(
    subscription && subscription.status === SubscriptionStatus.PastDue && isSubscriptionExpired(subscription.current_period_end),
  );
  const hasFreeSubscription = Boolean(subscription?.id?.includes('free_sub')) ?? false;
  const hasSubscriptionCancelAtPeriodEnd = Boolean(subscription?.cancel_at_period_end);
  const purchasedBoosters = subscription?.boosters ?? null;

  return {
    hasActiveSubscription,
    hasCanceledSubscription,
    hasExpiredSubscription,
    hasFreeSubscription,
    hasPastDueSubscription,
    hasPausedSubscription,
    hasSubscriptionCancelAtPeriodEnd,
    hasTrialPlan,
    hasUnpaidSubscription,
    purchasedBoosters,
  };
};
